import { SloType } from '@atlassiansox/phobos-client-ts';

import { sortAlphabetically } from '@/utils';
/**
 * Desired sorting is by name, then type
 */
export const sortSlos = (
  a: { name: string; type: SloType },
  b: { name: string; type: SloType }
): number => sortAlphabetically(a.name, b.name) || sortAlphabetically(a.type, b.type);
